import React from 'react'
import c from 'classnames'

import './index.scss'

export default function CherryGuage({
  level = 0,
  engagementScore,
  onClick = () => {},
  children,
}) {
  let engagementScoreLevels = [1, 2, 3, 4]

  level = engagementScore ? engagementScoreLevels.indexOf(engagementScore) + 1 : level

  return (
    <span
      className={c('frikin-cherry-gauge', `frikin-cherry-gauge-${level}`)}
      onClick={onClick}
    >
      <span role="img" aria-label="Captivated">
        🍒
      </span>
      <span role="img" aria-label="Engaged">
        🍒
      </span>
      <span role="img" aria-label="Buying Soon">
        🍒
      </span>
      <span role="img" aria-label="Close 'em">
        🍒
      </span>
      {children}
    </span>
  )
}
